/**
 * Makes an API-rooted address absolute for an `<img src>` or a link, now that the apps call the API
 * on its own origin (ADR-0008). Addresses stay relative on the wire and in storage
 * (files-in-blob-storage.md 2.4), so a change of API host never rewrites a stored setting.
 *
 * `/api/...` gains the origin; anything else (`https://`, `data:`, `blob:`, "") is returned as is.
 * With an empty origin (development, behind the Vite proxy) every address is returned as is.
 */
export function resolveApiUrl(origin: string, address: string): string {
  if (!origin || !address.startsWith("/api/")) return address;
  return `${origin.replace(/\/+$/, "")}${address}`;
}
